export const SHOP_ERROR_MAP: Record<string, string> = {
  'LL-1108': 'Die Auftragsreferenz ist zu lang. Bitte verwenden Sie eine kürzere Eingabe.',
  'LL-1109': 'Die Bestellung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
  'LL-1111': 'Ihr Warenkorb ist nicht mehr aktuell. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
  'LL-1112': 'Das ausgewählte Lieferdatum ist ungültig. Bitte wählen Sie ein gültiges Datum aus.',
};

export const SHOP_UNAVAILABLE_PRODUCTS_ERROR_CODES: string[] = ['LL-1107', 'LL-1114', 'LL-1115'];
